import styled from "styled-components";

export const VoucherCardFaceIconBox = styled.div<{iconUrl: string}>`
    background-image: url("${props => props.iconUrl}");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: 7.5em;
    height: 7.5em;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 6em;
        width: 6em;
    }
`;
